"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ratings = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var Ratings = function (_a) {
    var _b = _a.max, max = _b === void 0 ? 5 : _b, rating = _a.rating, fractions = _a.fractions, className = _a.className, containerClassName = _a.containerClassName, iconClassName = _a.iconClassName, descClassName = _a.descClassName, _c = _a.iconSize, iconSize = _c === void 0 ? 'md' : _c, _d = _a["data-testid"], testId = _d === void 0 ? 'rating' : _d, desc = _a.desc, onChange = _a.onChange, disabled = _a.disabled;
    var handleClick = function (newValue) { return function (e) {
        e.stopPropagation();
        var newRating;
        if (newValue > rating) {
            if (fractions) {
                newRating = newValue - 0.5 === rating ? newValue : newValue - 0.5;
            }
            else {
                newRating = newValue;
            }
        }
        else {
            newRating = newValue === rating ? newValue - 1 : newValue;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newRating);
    }; };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": testId, className: (0, classnames_1.default)('squid-flex', { 'squid-cursor-pointer': !!onChange }, containerClassName) }, { children: [Array(max)
                .fill(0)
                .map(function (_, index) {
                var rate = index + 1;
                var icon;
                if (rate > rating) {
                    icon = rate - 0.5 === rating && fractions ? 'Rating50' : 'Rating0';
                }
                else {
                    icon = 'Rating100';
                }
                return ((0, jsx_runtime_1.jsx)("button", __assign({ type: "button", onClick: disabled ? undefined : handleClick(rate), "data-testid": testId + (rate > rating ? 'Outline' : 'Solid'), className: className, disabled: disabled }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, size: iconSize, variant: "misc", className: iconClassName }) }), rate));
            }), desc && ((0, jsx_runtime_1.jsx)(Typography_1.Caption, __assign({ as: "p", className: descClassName, "data-testid": "".concat(testId, "Desc") }, { children: " (".concat(desc, ")") })))] })));
};
exports.Ratings = Ratings;
